import * as firebase from '../firebase';
import { h, Component } from 'preact';
import PropTypes from 'prop-types';
import { showError } from '../actions/alerts';

export default function UserLogin() {
  return (
    <div key="UserLogin">
      <h3>User Login</h3>

      <form onSubmit={onSubmitLogin}>
        <div className="form-group">
          <label className="form-label" htmlFor="email">Email Address</label>
          <input className="form-input" type="email" name="email" id="email" placeholder="user@example.com" required />
        </div>

        <div className="form-group">
          <label className="form-label" htmlFor="password">Password</label>
          <input className="form-input" type="password" name="password" id="password" required />
        </div>

        <button type="submit" className="btn btn-primary btn-block">Login</button>
      </form>
    </div>
  );
}

function onSubmitLogin(e) {
  e.preventDefault();

  let email = e.target['email'].value;
  let password = e.target['password'].value;

  // Log user in
  firebase.remote.login(email, password)
    .catch(showError);
}
